let icons = {
        "Coppers": require("@/assets/currency-icons/coin.png"),
        "Karma": require("@/assets/currency-icons/karma.png"),
        "Laurel": require("@/assets/currency-icons/laurel.png"),
        "Gem": require("@/assets/currency-icons/gem.png"),
        "Ascalonian Tear": require("@/assets/currency-icons/ascalonian_tear.png"),
        "Shard of Zhaitan": require("@/assets/currency-icons/shard_of_zhaitan.png"),
        "Fractal Relic": require("@/assets/currency-icons/fractal_relic.png"),
        "Seal of Beetletun": require("@/assets/currency-icons/seal_of_beetletun.png"),
        "Manifesto of the Moletariate": require("@/assets/currency-icons/manifesto_of_the_moletariate.png"),
        "Deadly Bloom": require("@/assets/currency-icons/deadly_bloom.png"),
        "Symbol of Koda": require("@/assets/currency-icons/symbol_of_koda.png"),
        "Flame Legion Charr Carving": require("@/assets/currency-icons/flame_legion_charr_carving.png"),
        "Knowledge Crystal": require("@/assets/currency-icons/knowledge_crystal.png"),
        "Badge of Honor": require("@/assets/currency-icons/badge_of_honor.png"),
        "Guild Commendation": require("@/assets/currency-icons/guild_commendation.png"),
        "Transmutation Charge": require("@/assets/currency-icons/transmutation_charge.png"),
        "Airship Part": require("@/assets/currency-icons/airship_part.png"),
        "Ley Line Crystal": require("@/assets/currency-icons/ley_line_crystal.png"),
        "Lump of Aurillium": require("@/assets/currency-icons/lump_of_aurillium.png"),
        "Spirit Shard": require("@/assets/currency-icons/spirit_shard.png"),
        "Pristine Fractal Relic": require("@/assets/currency-icons/pristine_fractal_relic.png"),
        "Geode": require("@/assets/currency-icons/geode.png"),
        "WvW Tournament Claim Ticket": require("@/assets/currency-icons/wvw_skirmish_claim_ticket.png"),
        "Bandit Crest": require("@/assets/currency-icons/bandit_crest.png"),
        "Magnetite Shard": require("@/assets/currency-icons/magnetite_shard.png"),
        "Provisioner Token": require("@/assets/currency-icons/provisioner_token.png"),
        "PvP League Ticket": require("@/assets/currency-icons/pvp_league_ticket.png"),
        "Proof Of Heroics": require("@/assets/currency-icons/proof_of_heroics.png"),
        "Unbound Magic": require("@/assets/currency-icons/unbound_magic.png"),
};

let currencies = [
        "Coppers",
        "Karma",
        /*
        "Laurel",
        "Fractal Relic",
        "Pristine Fractal Relic",
        "Badge of Honor",
        "Spirit Shard",
        "Magnetite Shard",
        "PvP League Ticket",
        "WvW Tournament Claim Ticket",
        "Proof of Heroics",
        "Guild Commendation",
        "Geode",
        "Bandit Crest",
        "Ascalonian Tear",
        "Seal of Beetletun",
        "Shard of Zhaitan",
        "Manifesto of the Moletariate",
        "Deadly Bloom",
        "Symbol of Koda",
        "Flame Legion Charr Carving",
        "Knowledge Crystal",
         */
];

export default {
        currencyIcons: icons,
        availableCurrencies: currencies
}
